[
  {
    "code": "LT-AL",
    "name": "Alytaus Apskritis"
  },
  {
    "code": "LT-KU",
    "name": "Kauno Apskritis"
  },
  {
    "code": "LT-KL",
    "name": "Klaipedos Apskritis"
  },
  {
    "code": "LT-MR",
    "name": "Marijampoles Apskritis"
  },
  {
    "code": "LT-PN",
    "name": "Panevežio Apskritis"
  },
  {
    "code": "LT-TA",
    "name": "Taurages Apskritis"
  },
  {
    "code": "LT-TE",
    "name": "Telšiu Apskritis"
  },
  {
    "code": "LT-UT",
    "name": "Utenos Apskritis"
  },
  {
    "code": "LT-VL",
    "name": "Vilniaus Apskritis"
  },
  {
    "code": "LT-SA",
    "name": "Šiauliu Apskritis"
  }
]